// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import { OptionGroup } from "../OptionGroup"
import { useI18n } from "@/i18n"
import type { AnswerDraft } from "../types"

interface Props {
  value: AnswerDraft
  onChange: (patch: AnswerDraft) => void
}

/** Step 1 (wire) — language choice. Also flips the app's live locale so the
 * rest of onboarding immediately renders in the chosen language. */
export function Step1Language({ value, onChange }: Props) {
  const { t, setLocale } = useI18n()
  const language = (value.language as string | undefined) ?? null

  return (
    <OptionGroup
      legend={t("onboarding.step1.title")}
      columns={2}
      value={language}
      onChange={next => {
        onChange({ language: next })
        if (next === "de" || next === "en") setLocale(next)
      }}
      options={[
        { value: "de", label: t("onboarding.step1.de") },
        { value: "en", label: t("onboarding.step1.en") },
      ]}
    />
  )
}
